import { Components, Theme, toggleButtonGroupClasses } from '@mui/material';

type ReturnType = Record<
  'MuiToggleButtonGroup',
  Components['MuiToggleButtonGroup']
>;

export default function ToggleButtonGroup(theme: Theme): ReturnType {
  return {
    MuiToggleButtonGroup: {
      styleOverrides: {
        root: {
          [`& .${toggleButtonGroupClasses.middleButton}`]: {
            borderColor: theme.palette.border.primary,
          },
          height: theme.spacing(10),
        },
      },
    },
  };
}
